import React, {Component} from "react";

class SearchDetailHeaderHeadline extends Component{
    constructor(props){
        super(props);
    }
    componentDidMount(){
        window.scrollTo(0,0);
    }
    render(){
        return(
            <div className="searchdetailheaderheadline">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <h1 className="searchhead">{this.props.result.title}</h1>
                            <p className="searchsubhead">{this.props.result.subname}</p>
                            <div className="ikonkax">

                            <a onClick={this.props.setSearchBack} className="backsearch backsearch2"><i class="fas fa-arrow-left"></i></a>
                            <a onClick={this.props.setSearch} className="backsearch"><i class="fas fa-search"></i></a>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-8">
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default SearchDetailHeaderHeadline;